import React from "react";
import { useNavigate } from "react-router-dom";
import { useWebsitePackages } from "../hooks/useWebsitePackages";
import styles from "./FeaturedPackages11.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const PackageCard = ({
  image,
  title,
  duration,
  price,
  fallbackImage,
  onClick
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <img
          src={image}
          alt={title}
          className={styles.image}
          onError={(e) => {
            e.target.src = fallbackImage;
          }}
        />

        <div className={styles.priceOverlay}>{price}</div>
      </div>

      <div className={styles.content}>
        <h3 className={styles.cardTitle}>{title}</h3>

        <p className={styles.duration}>{duration}</p>

        <div className={styles.priceRow}>
          <button className={styles.button} onClick={onClick}>
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

const FeaturedPackages11 = ({ companyId, mode, onNavigate, templateId }) => {

  const navigate = useNavigate();

  const { data: packages = [], isLoading, isError } =
    useWebsitePackages(companyId, "Holiday", mode);

  const handleViewDetails = (pkgId) => {
    if (mode === "builder") {
      onNavigate({ name: "package-details", params: { packageId: pkgId } });
    }
    else if (mode === "preview") {
      navigate(`/template-preview/${templateId}/package/${pkgId}`);
    }
    else {
      navigate(`/package/${pkgId}`);
    }
  };

  if (isLoading)
    return <div style={{ textAlign: "center" }}>Loading...</div>;

  if (isError) return null;

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>Our Featured Packages</h2>

      <div className={styles.grid}>
        {packages.slice(0, 6).map((pkg, index) => {

          const fallbackImage =
            fallbackImages[index % fallbackImages.length];

          const imageUrl =
            pkg?.imageSrc && pkg.imageSrc.trim() !== ""
              ? pkg.imageSrc
              : fallbackImage;

          return (
            <PackageCard
              key={pkg.packageId}
              image={imageUrl}
              title={pkg.packageName}
              duration={pkg.duration}
              price={`${pkg.currency} ${pkg.price}`}
              fallbackImage={fallbackImage}
              onClick={() => handleViewDetails(pkg.packageId)}
            />
          );
        })}
      </div>
    </section>
  );
};

export default FeaturedPackages11;